import Modal from "@/common/components/Modal";
import { useState } from "react";
import { useBillingBillResendBillDocumentMail } from "../../hooks/useBillingBillResendBillDocumentMail";
import Button from "@/common/components/Button";
import { ModalMessageSimple } from "@/common/components/ModalMessageSimple";

interface ResendMailModalProps {
  billId?: string;
}

const ResendMailModal = ({ billId }: ResendMailModalProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const [messages, setMessages] = useState<string[] | boolean>(false);

  const {
    mutate: resendBillMail,
    isPending: isResemdBillMailPending,
    isError: isResendBillMailError
  } = useBillingBillResendBillDocumentMail({
    id: billId,
    onSuccess: () => {
      setMessages(['Fatura reenviada com sucesso!']);
      setIsOpen(false);
    },
    onError: (error) => {
      if (error.response?.data.errors.base) setMessages(error.response?.data.errors.base)
    },
  });

  return (
    <>
      <Modal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        Trigger={(
          <Button id="resend_mail_button" variant="neutral">
            Reenviar email da fatura
          </Button>
        )}
        showClose={false}
        titleClass="text-2xl"
        subtitleClassName="mt-2 text-white-400"
        title="Reenviar email da fatura"
        subtitle={
          <div className="flex flex-col gap-1">
            <p>Você tem certeza?</p>
          </div>
        }
        useCancellableFooter
        onConfirm={() => resendBillMail()}
        confirmButtonClassName="bg-primary-blue"
        confirmButtonIsLoading={isResemdBillMailPending}
      />

      {messages && (
        <ModalMessageSimple
          messages={messages}
          setMessages={setMessages}
          isError={isResendBillMailError}
        />
      )}
    </>
  )
}

export default ResendMailModal;
